import { render, staticRenderFns } from "./BienDetailsCaracteristiques.vue?vue&type=template&id=14e99bee"
import script from "./BienDetailsCaracteristiques.vue?vue&type=script&lang=js"
export * from "./BienDetailsCaracteristiques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports